window.DrinkLab = window.DrinkLab || {};

/**
 * SIMPS Drink Lab launch recipes DL-001 to DL-034, all testingStatus:
 * approved. Original spec, IDs frozen per spec Sec 11.
 */
window.DrinkLab.RECIPES_PART1 = [
  // ---------------- COFFEE ----------------
  {
    id: 'DL-001', name: 'Salted Caramel Iced Coffee',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'salted_caramel',
    primaryProfiles: ['dessert', 'sweet'], secondaryProfiles: ['creamy'],
    adventure: 'classic', familiarity: 1, serve: ['cold', 'either'],
    intentTags: ['sweet_indulgent'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Salted Caramel', productId: 'salted_caramel' },
      { amount: '6 oz', ingredient: 'cold brew or iced coffee' },
      { amount: '2 oz', ingredient: 'milk of choice' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill a glass with ice.', 'Add syrup and coffee.', 'Top with milk and stir.'],
    dashQuote: 'Sweet, salty, and dangerously sippable.',
    description: 'A rich caramel coffee with a salty edge.',
    labPackId: 'coffeehouse_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-002', name: 'Brown Sugar Cinnamon Latte',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'brown_sugar_cinnamon',
    primaryProfiles: ['warm', 'cozy'], secondaryProfiles: ['spiced', 'sweet'],
    adventure: 'classic', familiarity: 2, serve: ['hot', 'either'],
    intentTags: ['warm_cozy'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Brown Sugar Cinnamon', productId: 'brown_sugar_cinnamon' },
      { amount: '2 oz', ingredient: 'espresso or strong coffee' },
      { amount: '6 oz', ingredient: 'steamed milk' }
    ],
    instructions: ['Add syrup to a mug.', 'Pour in espresso.', 'Top with steamed milk and stir.'],
    dashQuote: 'Cinnamon bun energy, in a cup.',
    description: 'Fresh-baked cinnamon bun flavour in latte form.',
    labPackId: 'dessert_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-003', name: 'Toasted Marshmallow Cold Brew',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'toasted_marshmallow',
    primaryProfiles: ['dessert', 'sweet'], secondaryProfiles: ['warm'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: ['sweet_indulgent', 'unexpected'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Toasted Marshmallow', productId: 'toasted_marshmallow' },
      { amount: '6 oz', ingredient: 'cold brew coffee' },
      { amount: '2 oz', ingredient: 'milk of choice', optional: true },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill a glass with ice.', 'Add syrup and cold brew.', 'Top with milk if using, stir.'],
    dashQuote: 'Campfire nostalgia meets your coffee order.',
    description: "A s'mores-inspired cold brew.",
    labPackId: 'dessert_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-004', name: 'Pistachio Iced Latte',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'pistachio',
    primaryProfiles: ['nutty', 'creamy'], secondaryProfiles: ['sweet'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: ['unexpected'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Pistachio', productId: 'pistachio' },
      { amount: '2 oz', ingredient: 'espresso' },
      { amount: '6 oz', ingredient: 'milk of choice' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill a glass with ice.', 'Add syrup and espresso.', 'Top with milk and stir.'],
    dashQuote: "Our most-requested flavour for a reason.",
    description: 'Smooth, nutty pistachio over espresso and milk.',
    labPackId: 'coffeehouse_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-005', name: 'Lavender Latte',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'lavender',
    primaryProfiles: ['floral', 'botanical'], secondaryProfiles: ['creamy'],
    adventure: 'experiment', familiarity: 3, serve: ['either'],
    intentTags: ['unexpected'],
    ingredients: [
      { amount: '0.75 oz', ingredient: 'SIMPS Lavender', productId: 'lavender' },
      { amount: '2 oz', ingredient: 'espresso' },
      { amount: '6 oz', ingredient: 'milk of choice' }
    ],
    instructions: ['Combine syrup and espresso.', 'Top with steamed or cold milk.'],
    dashQuote: 'Floral, calm, and quietly bold.',
    description: 'A soft floral twist on a classic latte.',
    labPackId: 'botanical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-006', name: 'Macadamia Cold Brew',
    drinkCompatibility: { coffee: 3 },
    heroProductId: 'macadamia_nut',
    primaryProfiles: ['nutty'], secondaryProfiles: ['sweet', 'creamy'],
    adventure: 'classic', familiarity: 2, serve: ['cold'],
    intentTags: ['smooth_creamy'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Macadamia Nut', productId: 'macadamia_nut' },
      { amount: '6 oz', ingredient: 'cold brew coffee' },
      { amount: '2 oz', ingredient: 'milk of choice', optional: true },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill a glass with ice.', 'Add syrup and cold brew.', 'Top with milk if using.'],
    dashQuote: 'A Hawaiian favourite, home in your glass.',
    description: 'Rich macadamia over smooth cold brew.',
    labPackId: 'coffeehouse_lab', testingStatus: 'approved'
  },

  // ---------------- CUSTOM SODA ----------------
  {
    id: 'DL-007', name: 'Prickly Pear Lime Soda',
    drinkCompatibility: { custom_soda: 3 },
    heroProductId: 'prickly_pear',
    primaryProfiles: ['fruity', 'refreshing'], secondaryProfiles: ['tart'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: ['bright_fruity'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Prickly Pear', productId: 'prickly_pear' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water.', 'Finish with lime and stir.'],
    dashQuote: "Desert melon, city sparkle.",
    description: 'A vibrant, subtly melon-like fizzy soda.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-008', name: 'Passionfruit Fizz',
    drinkCompatibility: { custom_soda: 3 },
    heroProductId: 'passionfruit',
    primaryProfiles: ['tropical', 'bright'], secondaryProfiles: ['tart'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: ['bright_fruity'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Passionfruit', productId: 'passionfruit' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water.', 'Finish with lime and stir.'],
    dashUpgrade: { productId: 'guava', amount: '¼–½ oz', description: 'Rounds it out with a sweeter tropical finish.' },
    dashQuote: 'Tropical, tart, and dangerously easy.',
    description: 'Bright passionfruit over sparkling water.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-009', name: 'Watermelon Lime Soda',
    drinkCompatibility: { custom_soda: 3 },
    heroProductId: 'watermelon',
    primaryProfiles: ['fruity', 'refreshing'], secondaryProfiles: ['sweet'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: ['bright_fruity', 'sweet_fun'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Watermelon', productId: 'watermelon' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water.', 'Finish with lime and stir.'],
    dashQuote: 'Peak summer, bottled.',
    description: 'Bold, juicy watermelon soda.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-010', name: 'Hibiscus Berry Soda',
    drinkCompatibility: { custom_soda: 3 },
    heroProductId: 'hibiscus',
    primaryProfiles: ['tart', 'floral'], secondaryProfiles: ['fruity'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: ['bright_fruity'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Hibiscus', productId: 'hibiscus' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water and stir.'],
    dashUpgrade: { productId: 'raspberry', amount: '¼ oz', description: 'Adds a deeper berry note.' },
    dashQuote: 'Deep ruby, deeply tart.',
    description: 'Bright, floral hibiscus with a tart edge.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-011', name: 'Blue Raspberry Lemon Fizz',
    drinkCompatibility: { custom_soda: 3 },
    heroProductId: 'blue_raspberry',
    primaryProfiles: ['candy', 'sweet'], secondaryProfiles: ['tart'],
    adventure: 'goose', familiarity: 2, serve: ['cold'],
    intentTags: ['sweet_fun'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blue Raspberry', productId: 'blue_raspberry' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh lemon' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water.', 'Finish with lemon and stir.'],
    dashQuote: 'Bold, nostalgic, unmistakably blue.',
    description: 'A nostalgic blue raspberry fizz.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },

  // ---------------- LEMONADE ----------------
  {
    id: 'DL-012', name: 'Raspberry Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'raspberry',
    primaryProfiles: ['fruity', 'tart'], secondaryProfiles: ['sweet'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Raspberry', productId: 'raspberry' },
      { amount: '8 oz', ingredient: 'fresh lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with lemonade and stir.'],
    dashQuote: 'Bright, tangy, ripe raspberries.',
    description: 'Classic lemonade with a raspberry lift.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-013', name: 'Passionfruit Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'passionfruit',
    primaryProfiles: ['tropical', 'tart'], secondaryProfiles: ['fruity'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Passionfruit', productId: 'passionfruit' },
      { amount: '8 oz', ingredient: 'fresh lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with lemonade and stir.'],
    dashQuote: 'Tropical thunder meets classic lemonade.',
    description: 'Lemonade with a tropical passionfruit twist.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-014', name: 'Lavender Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'lavender',
    primaryProfiles: ['floral', 'botanical'], secondaryProfiles: ['fresh'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '0.75 oz', ingredient: 'SIMPS Lavender', productId: 'lavender' },
      { amount: '8 oz', ingredient: 'fresh lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with lemonade and stir.'],
    dashQuote: 'A quiet, floral lemonade upgrade.',
    description: 'Lemonade with a soft lavender note.',
    labPackId: 'botanical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-015', name: 'Prickly Pear Lemonade',
    drinkCompatibility: { lemonade: 3 },
    heroProductId: 'prickly_pear',
    primaryProfiles: ['fruity', 'refreshing'], secondaryProfiles: ['tart'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Prickly Pear', productId: 'prickly_pear' },
      { amount: '8 oz', ingredient: 'fresh lemonade', productId: 'lemonade' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with lemonade and stir.'],
    dashQuote: 'Desert-bright, glass in hand.',
    description: 'Lemonade with a unique prickly pear edge.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },

  // ---------------- SPARKLING ----------------
  {
    id: 'DL-016', name: 'Elderflower Citrus Fizz',
    drinkCompatibility: { sparkling: 3 },
    heroProductId: 'elderflower',
    primaryProfiles: ['floral', 'botanical'], secondaryProfiles: ['bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Elderflower', productId: 'elderflower' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh citrus twist' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water.', 'Finish with citrus.'],
    dashQuote: 'Aromatic, elegant, endlessly sippable.',
    description: 'An elegant floral sparkler.',
    labPackId: 'botanical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-017', name: 'Grapefruit Spritz',
    drinkCompatibility: { sparkling: 3 },
    heroProductId: 'grapefruit',
    primaryProfiles: ['bright', 'tart'], secondaryProfiles: ['refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Grapefruit', productId: 'grapefruit' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water and stir.'],
    dashQuote: 'Crisp, zesty, refreshingly tangy.',
    description: 'A bright citrus spritz.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-018', name: 'Pomegranate Sparkler',
    drinkCompatibility: { sparkling: 3 },
    heroProductId: 'pomegranate',
    primaryProfiles: ['fruity', 'sweet'], secondaryProfiles: ['tart'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Pomegranate', productId: 'pomegranate' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water and stir.'],
    dashQuote: 'A grenadine shortcut with real flavour.',
    description: 'A sweet-tart pomegranate sparkler.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-019', name: 'Peach Fizz',
    drinkCompatibility: { sparkling: 3 },
    heroProductId: 'peach',
    primaryProfiles: ['fruity', 'sweet'], secondaryProfiles: ['refreshing'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Peach', productId: 'peach' },
      { amount: '6-8 oz', ingredient: 'sparkling water' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water and stir.'],
    dashQuote: 'Orchard-fresh and effervescent.',
    description: 'A juicy peach sparkler.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },

  // ---------------- CREAMY ----------------
  {
    id: 'DL-020', name: 'Strawberries & Cream',
    drinkCompatibility: { creamy: 3 },
    heroProductId: 'strawberry',
    primaryProfiles: ['fruity', 'creamy'], secondaryProfiles: ['sweet'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Strawberry', productId: 'strawberry' },
      { amount: '8 oz', ingredient: 'milk of choice' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup and milk.', 'Stir well.'],
    dashQuote: 'Berry rich, cream smooth.',
    description: 'A creamy strawberry classic.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-021', name: 'Coconut Cream',
    drinkCompatibility: { creamy: 3 },
    heroProductId: 'coconut',
    primaryProfiles: ['tropical', 'creamy'], secondaryProfiles: ['sweet'],
    adventure: 'classic', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Coconut', productId: 'coconut' },
      { amount: '8 oz', ingredient: 'milk of choice' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup and milk.', 'Stir well.'],
    dashQuote: 'Island getaway, in a glass.',
    description: 'A tropical, creamy coconut sipper.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-022', name: 'Pistachio Cream',
    drinkCompatibility: { creamy: 3 },
    heroProductId: 'pistachio',
    primaryProfiles: ['nutty', 'creamy'], secondaryProfiles: ['sweet'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Pistachio', productId: 'pistachio' },
      { amount: '8 oz', ingredient: 'milk of choice' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup and milk.', 'Stir well.'],
    dashQuote: 'Buttery, roasted, unmistakably pistachio.',
    description: 'A rich, nutty pistachio cream drink.',
    labPackId: 'coffeehouse_lab', testingStatus: 'approved'
  },

  // ---------------- ICED TEA ----------------
  {
    id: 'DL-023', name: 'Peach Iced Tea',
    drinkCompatibility: { iced_tea: 3 },
    heroProductId: 'peach',
    primaryProfiles: ['fruity', 'refreshing'], secondaryProfiles: ['sweet'],
    adventure: 'classic', familiarity: 1, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Peach', productId: 'peach' },
      { amount: '8 oz', ingredient: 'brewed iced tea', productId: 'iced_tea' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with iced tea and stir.'],
    dashQuote: 'Bellini backbone, tea-time approved.',
    description: 'A classic peach iced tea.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-024', name: 'Passionfruit Iced Tea',
    drinkCompatibility: { iced_tea: 3 },
    heroProductId: 'passionfruit',
    primaryProfiles: ['tropical', 'tart'], secondaryProfiles: ['refreshing'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Passionfruit', productId: 'passionfruit' },
      { amount: '8 oz', ingredient: 'brewed iced tea', productId: 'iced_tea' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with iced tea and stir.'],
    dashQuote: 'Tropical thunder, tea-time edition.',
    description: 'Iced tea with a tropical passionfruit lift.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-025', name: 'Blackberry Iced Tea',
    drinkCompatibility: { iced_tea: 3 },
    heroProductId: 'blackberry',
    primaryProfiles: ['fruity', 'tart'], secondaryProfiles: ['sweet'],
    adventure: 'classic', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blackberry', productId: 'blackberry' },
      { amount: '8 oz', ingredient: 'brewed iced tea', productId: 'iced_tea' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with iced tea and stir.'],
    dashQuote: 'Jammy, rich, tangy, vibrant.',
    description: 'A rich blackberry iced tea.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },

  // ---------------- MOCKTAIL ----------------
  {
    id: 'DL-026', name: 'Passionfruit Nojito',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'passionfruit',
    primaryProfiles: ['tropical', 'fresh'], secondaryProfiles: ['tart'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Passionfruit', productId: 'passionfruit' },
      { amount: '6 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh mint' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Muddle mint and lime in the glass.', 'Add syrup and ice.', 'Top with sparkling water and stir.'],
    dashQuote: 'All the mojito, none of the rum.',
    description: 'A tropical, herbaceous mocktail.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-027', name: 'Guava Lime Cooler',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'guava',
    primaryProfiles: ['tropical', 'fresh'], secondaryProfiles: ['fruity'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Guava', productId: 'guava' },
      { amount: '6 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water.', 'Finish with lime.'],
    dashQuote: 'Tropical thunder, no rum required.',
    description: 'A refreshing tropical cooler.',
    labPackId: 'tropical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-028', name: 'Hibiscus Mule',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'hibiscus',
    primaryProfiles: ['tart', 'spiced'], secondaryProfiles: ['floral'],
    adventure: 'goose', familiarity: 3, serve: ['cold'],
    intentTags: ['spicy_bold'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Hibiscus', productId: 'hibiscus' },
      { amount: '1 oz', ingredient: 'Local Ginger Beer', productId: 'ginger_beer' },
      { amount: '4-5 oz', ingredient: 'soda water' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill copper mug or glass with ice.', 'Add syrup and Local Ginger Beer.', 'Top with soda water and stir.', 'Finish with lime.'],
    dashQuote: 'Deep ruby, ginger-spiked.',
    description: 'A tart, spiced hibiscus mule.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-029', name: 'Elderflower Citrus Spritz',
    drinkCompatibility: { mocktail: 3 },
    heroProductId: 'elderflower',
    primaryProfiles: ['floral', 'botanical'], secondaryProfiles: ['bright'],
    adventure: 'experiment', familiarity: 2, serve: ['cold'],
    intentTags: [],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Elderflower', productId: 'elderflower' },
      { amount: '6 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh citrus twist' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup.', 'Top with sparkling water.', 'Finish with citrus.'],
    dashQuote: 'Built to be an alternative for St. Germain.',
    description: 'An elegant floral mocktail spritz.',
    labPackId: 'botanical_lab', testingStatus: 'approved'
  },

  // ---------------- COCKTAIL ----------------
  // Alcohol recommendations gated behind age/legal handling per store policy — see spec §21.
  {
    id: 'DL-030', name: 'Prickly Pear Margarita',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'prickly_pear',
    primaryProfiles: ['fruity', 'tart'], secondaryProfiles: ['refreshing'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    spirits: ['tequila'],
    intentTags: ['tropical'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Prickly Pear', productId: 'prickly_pear' },
      { amount: '1 oz', ingredient: 'SIMPS Margarita Mix', productId: 'margarita_mix' },
      { amount: '2 oz', ingredient: 'tequila' },
      { ingredient: 'ice' }
    ],
    instructions: ['Shake all ingredients with ice.', 'Strain over fresh ice.', 'Garnish with lime.'],
    dashQuote: 'Desert-bright, bar-cart ready.',
    description: 'A vibrant prickly pear margarita.',
    labPackId: 'goose_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-031', name: 'Blackberry Mule',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'blackberry',
    primaryProfiles: ['fruity', 'bold'], secondaryProfiles: ['tart'],
    adventure: 'experiment', familiarity: 3, serve: ['cold'],
    spirits: ['vodka', 'any'],
    intentTags: ['fruity'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Blackberry', productId: 'blackberry' },
      { amount: '2 oz', ingredient: 'vodka' },
      { amount: '1 oz', ingredient: 'Local Ginger Beer', productId: 'ginger_beer' },
      { amount: '4-5 oz', ingredient: 'soda water' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill mug or glass with ice.', 'Add syrup, vodka, and Local Ginger Beer.', 'Top with soda water and stir.', 'Finish with lime.'],
    dashQuote: 'Jammy, tangy, unmistakably bold.',
    description: 'A blackberry twist on the classic mule.',
    labPackId: 'berry_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-032', name: 'Elderflower Gin Fizz',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'elderflower',
    primaryProfiles: ['botanical', 'floral'], secondaryProfiles: ['bright'],
    adventure: 'classic', familiarity: 2, serve: ['cold'],
    spirits: ['gin'],
    intentTags: ['botanical'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Elderflower', productId: 'elderflower' },
      { amount: '2 oz', ingredient: 'gin' },
      { amount: '4 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh lemon' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup and gin.', 'Top with sparkling water.', 'Finish with lemon.'],
    dashQuote: 'The Hugo Spritz, house style.',
    description: 'A botanical gin fizz built for St. Germain fans.',
    labPackId: 'botanical_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-033', name: 'Peach Bellini',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'peach',
    primaryProfiles: ['fruity', 'sweet'], secondaryProfiles: ['bright'],
    adventure: 'classic', familiarity: 2, serve: ['cold'],
    spirits: ['sparkling_wine'],
    intentTags: ['fruity'],
    ingredients: [
      { amount: '0.75 oz', ingredient: 'SIMPS Peach', productId: 'peach' },
      { amount: '5 oz', ingredient: 'sparkling wine' }
    ],
    instructions: ['Add syrup to a flute.', 'Top slowly with chilled sparkling wine.'],
    dashQuote: 'The backbone of a classic Bellini.',
    description: 'A peach bellini made simple.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
  {
    id: 'DL-034', name: 'Grapefruit Paloma',
    drinkCompatibility: { cocktail: 3 },
    heroProductId: 'grapefruit',
    primaryProfiles: ['bright', 'tart'], secondaryProfiles: ['refreshing'],
    adventure: 'classic', familiarity: 2, serve: ['cold'],
    spirits: ['tequila'],
    intentTags: ['bright'],
    ingredients: [
      { amount: '1 oz', ingredient: 'SIMPS Grapefruit', productId: 'grapefruit' },
      { amount: '2 oz', ingredient: 'tequila' },
      { amount: '4 oz', ingredient: 'sparkling water' },
      { ingredient: 'fresh lime' },
      { ingredient: 'ice' }
    ],
    instructions: ['Fill glass with ice.', 'Add syrup and tequila.', 'Top with sparkling water.', 'Finish with lime.'],
    dashQuote: 'Crisp, zesty, bar-ready.',
    description: 'A bright grapefruit paloma.',
    labPackId: 'bright_lab', testingStatus: 'approved'
  },
];